import { render, staticRenderFns } from "./matchHDPOUMLOdds.vue?vue&type=template&id=6621d5b5&lang=pug&"
import script from "./matchHDPOUMLOdds.vue?vue&type=script&lang=js&"
export * from "./matchHDPOUMLOdds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports